import Imgix from 'react-imgix';
import LazyLoad from 'react-lazyload';
import { Animation, Shadows, } from '@zapier/design-system/dist/theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/common-utils';
const Styles = labelStyles(__filename, {
    root: (props) => [
        {
            borderRadius: 0,
            transitionProperty: 'box-shadow',
            transitionTimingFunction: Animation.transitionTimingFunction,
            transitionDuration: Animation.transitionDuration,
            width: '100%',
        },
        props.hasRadius &&
            withModifier('hasRadius', {
                borderRadius: props.borderRadius,
            }),
        props.shadow &&
            withModifier('hasShadow', {
                boxShadow: Shadows[props.shadow],
            }),
        props.objectFit &&
            withModifier('objectFit', {
                objectFit: props.objectFit,
            }),
        props.objectPosition &&
            withModifier('objectPosition', {
                objectPosition: props.objectPosition,
            }),
        props.width &&
            withModifier('width', {
                width: props.width,
            }),
    ],
});
const Img = (props) => {
    const { alt, ariaHidden, aspectRatio, height, lazyloadOffset, lazyloadOverflow, lazyloadThrottle, onError, onLoad, sizes, src, width, } = props;
    const imageNode = (isolateComponent(Imgix, { css: Styles.root(props), "data-testid": "img", height: height, htmlAttributes: {
            alt,
            'aria-hidden': ariaHidden,
            onError,
            onLoad,
        }, imgixParams: {
            ar: aspectRatio,
        }, sizes: sizes, src: src, width: width }));
    return lazyloadOffset === null ? (imageNode) : (isolateComponent(LazyLoad, { height: height, offset: lazyloadOffset, once: true, overflow: lazyloadOverflow, throttle: lazyloadThrottle }, imageNode));
};
Img.defaultProps = {
    hasRadius: true,
    borderRadius: 10,
    lazyloadOffset: 200,
    lazyloadThrottle: false,
};
export { Img };
//# sourceMappingURL=Img.js.map
